<template>
  <div>
    <div
      v-if="error"
      class="alert alert-danger alert-dark-danger text-center"
    >
      {{ $t('sentence.error_message_close_window') }}
    </div>
  </div>
</template>

<script>
import api from '@/common/api';
import { notify } from '@/common/utils/notify';
import { mapActions } from 'vuex';

export default {
  name: 'EmailChangeConfirm',
  data() {
    return {
      error: false,
    };
  },
  methods: {
    ...mapActions(['refreshUser']),
    async confirmEmailChange() {
      const response = await api.patch(`email-change-requests/${this.$route.params.uuid}/confirm/`);
      if (response.status !== 200) {
        this.error = true;
      }

      notify(
        'phrase.change_email',
        'sentence.change_email_success',
        'success',
      );
      await this.refreshUser();
      await this.$router.push({ name: 'dashboard' });
    },
  },
  created() {
    this.confirmEmailChange();
  },
};
</script>
